import { getValidChangedProducts } from '@/creditflowresearch/application/actions/profile/helpers/getValidChangedProducts';
import { isRedirectToDefaultActive } from '@/creditflowresearch/application/actions/profile/helpers/isRedirectToDefaultActive';
import { getBaseProfileFilters } from '@/creditflowresearch/application/actions/profile/helpers/getBaseProfileFilters';

export const initProfilePage = ({ ...config }: {
  skipNextUpdate: boolean,
  profileType: string,
  isConsumerOverview: boolean,
  headerData: any,
  query: any,
  pathname: string,
  router?: any,
}): void => {
  const {
    headerData,
    pathname,
    query,
    router,
   } = config;
  const {
    ...changedProducts
  } = getValidChangedProducts({
    productsCollection: headerData.products,
    regionsCollection: headerData.regions,
    pathname,
    query,
  });

  if (isRedirectToDefaultActive({ ...changedProducts }, router ? { push: router.push } : undefined)) return;
  getBaseProfileFilters({ changedProducts, ...config });
};
